import {post, get, remove, patch} from '@/lib/axios';

const events = {
  async get_events(type, date_to, date_from, page_num, page_size, name) {
    return get(`/events`, {type, date_to, date_from, page_num, page_size, name});
  },
  async post_event(data) {
    return post(`/events`, data);
  },
  async get_event_by_id(id) {
    return get(`/events/${id}`);
  },
  async get_event_comments(id, data) {
    return get(`/events/${id}/comment`, data);
  },
  async post_event_comment(id, data) {
    return post(`/events/${id}/comment`, data);
  },
  async edit_event_comment(event_id, comment_id, data) {
    return patch(`/events/${event_id}/comment/${comment_id}`, data);
  },
  async delete_event_comment(event_id, comment_id, data) {
    return remove(`/events/${event_id}/comment/${comment_id}`, data);
  },
  async register_event(id, data) {
    return post(`/events/${id}/register`, data);
  },
  async cancel_event(id) {
    return remove(`/events/${id}/register`);
  },
  async like_event(id, data) {
    return post(`/events/${id}/like`, data);
  },
  async unlike_event(id, data) {
    return remove(`/events/${id}/like`, data);
  },
  async get_user_events(id) {
    return get(`/events/user/${id}`);
  },
};

export {events as default};
